import React, { useContext } from 'react';
import "../../../../ui-styles/list/contactInfoList.css";
import { Link } from 'react-router-dom';
import { LangCtx } from "../../../../lib/context";
import "../successFailure.css";
// import Loader from '../../../../lib/ui/loader/Loader';
import "../../Styles.css";

const PaymentFailure = (props) => {
    const { l } = useContext(LangCtx);

    return (
        <div className="baseContainer">
        {/* <div className="successFailureCntnr baseContainer">
            <div className="sfHeader">
                <div className="sfBranding">
                    <img src="/images/logos/inclinix-logo.png" alt="logo" className="invertWhite" />
                </div>
            </div> */}
                <> <div className="sfBdy">
                    <div className="sfBdyOverflow">
                        <div className="sfBdyContainer verticlaColCenter">
                            <div className="smgBody verticlaColCenter">
                                <div className="sfCircle failureColor"></div>
                                <span className="sfHdnTxt cntrTxt">Your payment failed</span>
                                <p className="pTxt cntrTxt">Unfortunately the payment was rejected</p>

                                <div className="detailsItem mrgnTopM">
                                    <Link to="/appointments" alt="Upcoming Appointments" className="pushLink">
                                        Please try again
                                </Link>
                                </div>
                                <div className="detailsItem">
                                    <Link to="/appointments" alt="Upcoming Appointments" className="sfLinkTxt">
                                        {l.goto_up_meet}
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                </>
        </div>
    )
}

export default PaymentFailure;